"use client";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

/**
 * Every control on the icon rail names itself on hover and focus, beside
 * itself on the side the panel opens. Needs the side nav's TooltipProvider.
 */
export default function RailTooltip({ label, side = "right", children }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side={side}>{label}</TooltipContent>
    </Tooltip>
  );
}
